// src/pages/Operations/Operations.tsx
import React from 'react';
import { OperationsTable } from './components/OperationsTable';

export const Operations: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <OperationsTable />
    </div>
  );
};